import { createOptionsFrom } from "@/lib/common/Option";

export const CollectionSortOrderLabels = {
	Alphabetical: "Alphabetical",
	Chronological: "Chronological",
	Value: "Value",
	PercentageGain: "Percentage Gain"
} as const;

export type CollectionSortOrder = keyof typeof CollectionSortOrderLabels;

export const CollectionSortOrderOptions = createOptionsFrom(CollectionSortOrderLabels);
